import { Eyebrow } from '../atoms/Eyebrow';
import { Icon } from '../atoms/Icon';

export interface SecHeadLink {
  label: string;
  href: string;
}

export interface SecHeadProps {
  eyebrow: string;
  title: string;
  /** Right-aligned descriptive lead. Ignored if `link` is provided. */
  lead?: string;
  /** Right-aligned outbound link. Takes precedence over `lead`. */
  link?: SecHeadLink;
  magenta?: boolean;
}

export function SecHead({ eyebrow, title, lead, link, magenta }: SecHeadProps) {
  return (
    <div className="sechead reveal">
      <div>
        <Eyebrow magenta={magenta}>{eyebrow}</Eyebrow>
        <h2>{title}</h2>
      </div>
      {link ? (
        <a className="seclink" href={link.href} target="_blank" rel="noreferrer noopener">
          {link.label}
          <Icon name="arrow-up-right" size={15} />
        </a>
      ) : lead ? (
        <p>{lead}</p>
      ) : null}
    </div>
  );
}
